module.exports = __webpack_public_path__ + "static/logo-trees-for-future-white.34c41933.png";